var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 44,
    viewBox: "0 0 105 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.547 22.4776C104.547 15.0432 100.946 9.17688 94.0636 9.17688C87.1519 9.17688 82.97 15.0431 82.97 22.4195C82.97 31.1609 87.9069 35.5751 94.9929 35.5751C98.4488 35.5751 101.062 34.791 103.037 33.6874V27.8792C101.062 28.8666 98.7973 29.4765 95.9222 29.4765C93.1053 29.4765 90.6077 28.4891 90.2883 25.0623H104.489C104.489 24.6847 104.547 23.1746 104.547 22.4776ZM90.2012 19.7187C90.2012 16.4371 92.205 15.0722 94.0346 15.0722C95.8061 15.0722 97.6937 16.4371 97.6937 19.7187H90.2012Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7602 9.17688C68.9142 9.17688 67.0846 10.5128 66.0682 11.4421L65.6906 9.64153H59.3016V43.5033L66.5619 41.9641L66.5909 33.7455C67.6364 34.5006 69.1756 35.5751 71.7312 35.5751C76.9295 35.5751 81.6632 31.3932 81.6632 22.1872C81.6341 13.7653 76.8424 9.17688 71.7602 9.17688ZM70.0177 29.1861C68.3043 29.1861 67.2879 28.5762 66.5909 27.8212L66.5619 17.047C67.3169 16.2048 68.3624 15.624 70.0177 15.624C72.6605 15.624 74.49 18.5861 74.49 22.3905C74.49 26.282 72.6895 29.1861 70.0177 29.1861Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3115 7.46352L56.6008 5.89531V0L49.3115 1.53917V7.46352Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6008 9.67065H49.3115V35.0815H56.6008V9.67065Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4995 11.8196L41.0348 9.67061H34.762V35.0814H42.0222V17.8602C43.7356 15.624 46.6397 16.0306 47.54 16.35V9.67061C46.6107 9.32212 43.2129 8.68321 41.4995 11.8196Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.979 3.36865L19.8931 4.87878L19.864 28.1406C19.864 32.4386 23.0876 35.6041 27.3856 35.6041C29.767 35.6041 31.5094 35.1685 32.4678 34.6457V28.7504C31.5385 29.128 26.95 30.4638 26.95 26.1658V15.8563H32.4678V9.67054H26.95L26.979 3.36865Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34736 17.047C7.34736 15.9144 8.27667 15.4788 9.81584 15.4788C12.0229 15.4788 14.8109 16.1467 17.018 17.3374V10.5128C14.6076 9.55441 12.2262 9.17688 9.81584 9.17688C3.92053 9.17688 0 12.2552 0 17.3955C0 25.4108 11.0356 24.133 11.0356 27.5888C11.0356 28.9247 9.87392 29.3603 8.24763 29.3603C5.83723 29.3603 2.75889 28.3729 0.31945 27.0371V33.9488C3.02026 35.1104 5.75011 35.6041 8.24763 35.6041C14.2881 35.6041 18.441 32.6129 18.441 27.4146C18.412 18.7604 7.34736 20.2996 7.34736 17.047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe_logo.e58e4147a7b9e35df124522e2b6d45b3.svg";
export { ForwardRef as ReactComponent };